import { usePage } from '@websolutespa/bom-mixer-hooks';
import { useRouter } from 'next/router';
import React, { Children } from 'react';
import { Link, LinkProps } from '../link/link';

export type NavLinkProps = Omit<LinkProps, 'children'> & {
  children: React.ReactElement;
  activeClassName?: string;
};

export type NavLinkComponent = React.ForwardRefExoticComponent<Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof NavLinkProps> & NavLinkProps & React.RefAttributes<HTMLAnchorElement>>;

export const NavLink: NavLinkComponent = React.forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ children, activeClassName = 'active', ...props }: NavLinkProps, forwardedRef) => {
    const child = Children.only(children);
    const childClassName = (child.props as any).className || '';
    const page = usePage();
    const router = useRouter();
    const pathname = page?.href || router.asPath;
    const isActive = pathname && (pathname === props.href || pathname === props.as);
    const className = isActive ? `${childClassName} ${activeClassName}`.trim() : childClassName;
    return (
      <Link ref={forwardedRef} {...props}>
        {isActive ? React.cloneElement(children as React.ReactElement<HTMLElement>, {
          className: className || null,
        }) : children}
      </Link>
    );
  }
);

NavLink.displayName = 'NavLink';
